import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

export default function GridSectionHeader({
  sectionName,
  sx = {
    p: 1,
    pl: 1.8,
    mt: 1,
    mb: 1,
    fontSize: 16,
    fontWeight: "bold",
    color: "#FFFFFF", //WHITE
    // color: "#000000", //BLACK
    // backgroundColor: "#d9d9d9",
    backgroundColor: "#10B981",
  },
}) {
  return (
    <Grid size={12}>
      {/* <InputLabel sx={{ p: 2, fontSize: 20, fontWeight: "bold" }}>
          Residential
        </InputLabel> */}
      <Typography variant="h6" gutterBottom sx={sx}>
        {sectionName}
      </Typography>
    </Grid>
  );
}
